import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React from 'react';
import Trans, { t } from '../../commons/Translate.js'

const ConfirmDestroyItemDialog = ({open, onClose, perspective, item}) => {
  perspective = perspective || 'recipient'
  const title = perspective === 'creator' ? t('Auftrag wirklich löschen?') : t('Auftrag wirklich ablehnen?')
  const content = perspective === 'creator' ? <Trans substitutions={[item.assignedTo.name]}>Anschließend wird der Auftrag aus dieser Liste und der Liste von <i>$0</i> entfernt.</Trans> : t('Anschließend wird der Auftrag aus Ihrer Liste gelöscht.')
  return <Dialog open={open} onClose={() => onClose(false)}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions>
      <Button autoFocus onClick={() => onClose(false)} color="primary">{t('Nein')}</Button>
      <Button onClick={() => onClose(true)} color="primary">{t('Ja')}</Button>
    </DialogActions>
  </Dialog>
}

export default ConfirmDestroyItemDialog